module.exports = __webpack_public_path__ + "media/stop-14.176646e8.mp3";